import React from 'react';
// import icon_X from '../img/x_purple.png';
// import icon_LI from '../img/Linkedin_purple.png';
import logo_cupra from '../img/used_by/cupra_logo.svg';
import logo_hedera from '../img/used_by/hedera_logo.svg';
import logo_hyperreal from '../img/used_by/hyperreal_logo 1.png';
import logo_mediapro from '../img/used_by/mediapro_logo.svg';
import logo_a3 from '../img/used_by/A3Media_logo.svg';
import logo_ntwk from '../img/used_by/ntwk_logo.png';
import logo_sm from '../img/about/used_by/logo_strikermanager3.png';
import logo_eb from '../img/Investors/earlybird_logo.svg';
import logo_tg from '../img/Investors/target_global_logo.svg';
import logo_ad from '../img/Investors/Adara_logo.svg';
import logo_4f from '../img/Investors/4founders_logo.png';
// import freeverse_team from '../img/freeverse_team.jpg';

const About = () => {
    return (
        <>
        <section className="mx-auto px-8 sm:px-20 lg:px-40 pb-10 mb-5 bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-fvorange from-0% via-fvpurple to-[#211434] to-80% py-20">
            <div className="flex flex-col space-y-4 justify-center items-center text-center mb-20">
                <div className="text-4xl text-fvyellow">Founding Team</div>
                <div className="text-lg">
                    LAOS was founded & promoted by Freeverse. 
                    Freeverse&apos;s Layer-2, launched in 2021 and focused on dynamic assets, was used by Cupra, Hyperreal, Mediapro & various video games and brands.
                    Now, we are excited to extend our vision with a universal Layer-1. 
                </div>
            </div>
        </section>
        <div className="background-about-main text-fvdarkpurple">

    <section className="container mx-auto px-8 sm:px-20 lg:px-40 space-y-4">
        <div className="flex flex-col justify-center items-center text-center">
            <div className="w-1/8 border-2 border-fvyellow text-fvyellow px-12 py-3 rounded-full ">Used By</div>
            <div className="flex flex-row justify-center items-center px-2 md:px-10 space-x-2 md:space-x-20 mt-8">
                <div><img src={logo_cupra} alt="Cupra" /></div>
                <div><img src={logo_hedera} alt="Hedera" /></div>
                <div><img src={logo_hyperreal} alt="Hyperreal" /></div>
            </div>
            <div className="flex flex-row justify-center items-center px-2 md:px-10 space-x-8 md:space-x-20 mt-8">
                <div><img src={logo_mediapro} alt="Mediapro" /></div>
                <div><img src={logo_a3} alt="A3Media" /></div>
                <div><img src={logo_ntwk} alt="Cupra" /></div>
                <div><img src={logo_sm} alt="Striker Manager" /></div>
            </div>
        </div>
        <div className="flex flex-col justify-center items-center py-10 text-center">
            <div className="w-1/8 border-2 border-fvyellow text-fvyellow px-12 py-3 rounded-full ">Investors</div>
            <div className="flex flex-row justify-center items-center px-10 space-x-8 md:space-x-20 mt-8">
                <div><img src={logo_eb} alt="Earlybird" /></div>
                <div><img src={logo_tg} alt="Target Global" /></div>
            </div>
            <div className="flex flex-row justify-center items-center px-10 space-x-8 md:space-x-20 mt-8">
                <div><img src={logo_ad} alt="Adara" /></div>
                <div><img src={logo_4f} alt="4 Founders" /></div>
            </div>
        </div>     
    </section>
</div>
{/* <div className="flex justify-center items-center">
    <div><img src={freeverse_team} alt="Freeverse" /></div>
</div> */}
        </>
    )
};
  
export default About;